<template>
  <MTooltip placement="top">
    <template v-slot:trigger>
      <a href="javascript:;" v-on="$listeners">
        <MIcon name="one-column" />
      </a>
    </template>
    {{ $t('expand') }}
  </MTooltip>
</template>

<script>
export default {
  name: 'ControlExpandButton',
}
</script>
